var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeaderIconHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.71364 9.10377L1.5 8.34685V14.4999H2.5V7.38429L7.98829 2.10146L13.5 7.40644V14.4999H14.5V8.36893L15.2864 9.12582L16 8.41192L7.98826 0.700684L0 8.3899L0.71364 9.10377ZM5.7 14.4933H6.69929V9.99987H9.31072V14.4933H10.31V8.99987H5.7V14.4933Z"
  })));
}
export default SvgHeaderIconHome;